<template>
  <v-dialog
    v-model="showDialog"
    max-width="500px"
    transition="dialog-transition"
    @click:outside="close"
  >
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $translate('WARNING') }}
      </v-card-title>
      <v-card-text class="pt-4">
        {{ forAgeText }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" depressed @click="close">
          {{ $translate('CLOSE') }}
        </v-btn>
        <v-btn
          color="primary"
          class="primary-font-color"
          depressed
          @click="confirm"
        >
          {{ $translate('ACCEPT') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ProductAgeAlert',
  props: {
    value: Boolean,
    forAge: Number,
  },
  emits: ['input', 'confirm'],
  data() {
    return {
      showDialog: this.value,
    };
  },
  watch: {
    value() {
      this.showDialog = this.value;
    },
  },
  computed: {
    forAgeText() {
      return this.$translate('EVENT_FORAGE_MESSAGE').replace(
        '(age)',
        this.forAge
      );
    },
  },
  methods: {
    close() {
      this.showDialog = false;
      this.updateValue();
    },
    confirm() {
      this.showDialog = false;
      this.$emit('confirm');
      this.updateValue();
    },
    updateValue() {
      this.$emit('input', this.showDialog);
    },
  },
};
</script>
